export const OPEN_ANSWER_TEST_ROUTES = {
    ROOT: "/open-answer",
    CREATE_TEST: "/open-answer/create-test",
    CONSTRUCTOR: "/open-answer/constructor",
    EDITING: "/open-answer/editing/:id",
};
